import React from 'react';
import { string } from 'prop-types';

const StatusWaitingAtDestinationColor = ({
  className = '',
  color = '#9a6412',
}) => (
  <svg className={className} width="1.4rem" height="1.4rem" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.6226 1.31464L3.27885 1.31465L3.2788 3.12933L4.54159 3.87362L4.20837 4.43898L2.62254 3.50429L2.6226 1.31464Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M3.0625 6.125C4.75387 6.125 6.125 4.75387 6.125 3.0625C6.125 1.37113 4.75387 0 3.0625 0C1.37113 0 0 1.37113 0 3.0625C0 4.75387 1.37113 6.125 3.0625 6.125ZM3.0625 5.25C4.27062 5.25 5.25 4.27062 5.25 3.0625C5.25 1.85438 4.27062 0.875 3.0625 0.875C1.85438 0.875 0.875 1.85438 0.875 3.0625C0.875 4.27062 1.85438 5.25 3.0625 5.25Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M11.55 3.32825V6.01999L14 7V14H8.16667V7L10.6166 6.02001V4.83841L4.54997 7.87175V8.35332L7 9.33333V14H1.16667V9.33333L3.61664 8.35334V7.29491L11.55 3.32825ZM2.1 11.4333V13.0667H6.06667V11.4333H2.1ZM2.1 10.5V9.96523L4.08333 9.1719L6.06667 9.96523V10.5H2.1ZM13.0667 7.6319V8.16667H9.1V7.6319L11.0833 6.83856L13.0667 7.6319ZM9.1 13.0667V9.1H10.6166V13.0667H9.1ZM11.55 13.0667V9.1H13.0667V13.0667H11.55Z" fill={color} />
  </svg>
);

StatusWaitingAtDestinationColor.propTypes = {
  className: string,
  color: string,
};

export default StatusWaitingAtDestinationColor;
